export const ArrowLeftSVG = () => {
  return (
    <svg width="16" height="12" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.61822 8.06687L9.27555 13.7242C9.79617 14.2448 9.79617 15.0889 9.27555 15.6095C8.75493 16.1302 7.91084 16.1302 7.39022 15.6095L0.790362 9.00968C0.269662 8.48898 0.269662 7.64476 0.790362 7.12406L7.39022 0.524199C7.91084 0.00357802 8.75493 0.0035781 9.27555 0.524199C9.79617 1.04482 9.79617 1.88891 9.27555 2.40953L3.61822 8.06687Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20.666 8C20.666 8.73638 20.0691 9.33333 19.3327 9.33333L2.66602 9.33333C1.92964 9.33333 1.33268 8.73638 1.33268 8C1.33268 7.26362 1.92964 6.66666 2.66602 6.66666L19.3327 6.66667C20.0691 6.66667 20.666 7.26362 20.666 8Z"
        fill="currentColor"
      />
    </svg>
  )
}
